// extracted by mini-css-extract-plugin
export default {"wishlists_section":"WishlistsPage_wishlists_section__Yk7kN"};